import { render, staticRenderFns } from "./Coupons.vue?vue&type=template&id=0413dee6&"
import script from "./Coupons.vue?vue&type=script&lang=js&"
export * from "./Coupons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0413dee6')) {
      api.createRecord('0413dee6', component.options)
    } else {
      api.reload('0413dee6', component.options)
    }
    module.hot.accept("./Coupons.vue?vue&type=template&id=0413dee6&", function () {
      api.rerender('0413dee6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Coupons.vue"
export default component.exports